<template>
  <slot />
</template>

<script setup lang="ts">
import { onErrorCaptured } from 'vue';
import { useRouter } from 'vue-router';
import { sentryService } from '@/core/services/sentry/sentryService';

defineOptions({
  name: 'ErrorBoundary'
});

const router = useRouter();

onErrorCaptured((error, instance, info) => {
  const componentName = instance?.$options?.name || instance?.$options?.__name || "Unknown";
  const componentType = instance?.$?.type?.name || "UnknownType";
  
  // Log detalhado no console para desenvolvimento
  console.error(`[ErrorBoundary] Erro capturado em ${componentName}:`, {
    error,
    errorInfo: info,
    component: instance,
    componentType,
    props: instance?.$props,
    route: router.currentRoute.value
  });
  
  // Capturar no Sentry com contexto expandido
  sentryService.captureError(
    error,
    "error-boundary",
    {
      title: `Erro em ${componentName}`,
      message: error.message || "Erro desconhecido"
    },
    {
      componentName,
      componentType,
      errorInfo: info,
      error_source: "error-boundary",
      componentTree: instance?.$parent?.$options?.name || "Root",
      route: router.currentRoute.value.path,
      routeName: router.currentRoute.value.name as string | undefined,
      routeParams: router.currentRoute.value.params,
      routeQuery: router.currentRoute.value.query,
      // Adicionar informações sobre o estado do componente
      hasVNodes: !!instance?.$.vnode,
      isMounted: instance?.$?.isMounted || false,
      isUnmounted: instance?.$?.isUnmounted || false,
      // Stack trace parseado
      errorStack: error instanceof Error ? error.stack : String(error),
      // Tipo de erro
      errorType: error?.constructor?.name || typeof error
    }
  );
  
  // Permitir que o erro continue propagando para não bloquear a interface
  return true;
});
</script>